function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createOAuth2Application, deleteOAuth2Authorization, getOAuth2Applications } from '@/actions/AuthActions';
import useAppStore from '@/stores/AppStore';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Table from '../Table';
import { faChevronRight, faCube, faTrash } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import SettingsPanel from '../SettingsPanel';
import { useNavigate } from 'react-router';
import { DynamicWebRoutes } from '@/utils/constants';
import InputModal, { DefaultInput } from '../InputModal';
import { ActionIcon, Button, Table as MantineTable, Text, UnstyledButton } from '@mantine/core';
import TableHeading from '../TableHeading';
import Icon, { IconSizes } from '../Icon';
import styles from './ConnectionsPanel.module.scss';
import Heading from '../Heading';
import { useDisclosure } from '@mantine/hooks';
function ConnectionsPanel() {
    var intl = useIntl();
    var isDeveloper = useAppStore(function(state) {
        return state.isDeveloper;
    });
    var _useDisclosure = _sliced_to_array(useDisclosure(), 2), newApplicationModalOpen = _useDisclosure[0], newApplicationModalHandlers = _useDisclosure[1];
    var _useDisclosure1 = _sliced_to_array(useDisclosure(), 2), deleteConnectionModalOpen = _useDisclosure1[0], deleteConnectionModalHandlers = _useDisclosure1[1];
    var _React_useState = _sliced_to_array(React.useState(null), 2), selectedConnection = _React_useState[0], setSelectedConnection = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), applications = _React_useState1[0], setApplications = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(null), 2), connections = _React_useState2[0], setConnections = _React_useState2[1];
    var navigate = useNavigate();
    React.useEffect(function() {
        getOAuth2Applications().then(function(param) {
            var applications = param.applications, authorizedApplications = param.authorizedApplications;
            setApplications(applications);
            setConnections(authorizedApplications);
        }).catch(console.error);
    }, []);
    var createApplication = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(name) {
            var application;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (name.trim() === '') {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            createOAuth2Application(name)
                        ];
                    case 1:
                        application = _state.sent();
                        navigate(DynamicWebRoutes.OAUTH2_APPLICATION_SETTINGS(application.clientId));
                        return [
                            2
                        ];
                }
            });
        });
        return function(name) {
            return _ref.apply(this, arguments);
        };
    }(), [
        navigate
    ]);
    var disconnectApplication = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (selectedConnection == null) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        deleteOAuth2Authorization(selectedConnection.clientId)
                    ];
                case 1:
                    _state.sent();
                    setConnections(function(connections) {
                        return (connections !== null && connections !== void 0 ? connections : []).filter(function(c) {
                            return c.clientId !== selectedConnection.clientId;
                        });
                    });
                    return [
                        2
                    ];
            }
        });
    }), [
        selectedConnection
    ]);
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "l9CREU",
                    defaultMessage: "Connections"
                })
            }),
            /*#__PURE__*/ _jsx(Table, {
                data: connections,
                extraData: [
                    deleteConnectionModalOpen
                ],
                renderHeader: function() {
                    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                        children: [
                            /*#__PURE__*/ _jsx(TableHeading, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "jwhET3",
                                    defaultMessage: "Application"
                                })
                            }),
                            /*#__PURE__*/ _jsx(TableHeading, {
                                visibleFrom: "sm",
                                alignRight: true,
                                className: styles.actionsHeader,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "wL7VAE",
                                    defaultMessage: "Actions"
                                })
                            })
                        ]
                    });
                },
                renderRow: function(application) {
                    var onDisconnect = function onDisconnect() {
                        setSelectedConnection(application);
                        deleteConnectionModalHandlers.open();
                    };
                    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                        children: [
                            /*#__PURE__*/ _jsx(MantineTable.Td, {
                                className: styles.applicationColumn,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    className: styles.applicationName,
                                    children: application.name
                                })
                            }),
                            /*#__PURE__*/ _jsx(MantineTable.Td, {
                                className: styles.actionsColumn,
                                children: /*#__PURE__*/ _jsx(ActionIcon, {
                                    size: "sm",
                                    "aria-label": intl.formatMessage({
                                        id: "qj1uhz",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Disconnect"
                                            }
                                        ]
                                    }),
                                    onClick: onDisconnect,
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        size: IconSizes.SM,
                                        icon: faTrash
                                    })
                                })
                            })
                        ]
                    });
                },
                renderEmptyState: function() {
                    return /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "medMEK",
                        defaultMessage: "No connections"
                    });
                }
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: deleteConnectionModalOpen,
                onClose: deleteConnectionModalHandlers.close,
                title: intl.formatMessage({
                    id: "CMhN3o",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Disconnect Application"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "D4fmO9",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to disconnect this application?"
                        }
                    ]
                }),
                onSubmit: disconnectApplication,
                submitText: intl.formatMessage({
                    id: "qj1uhz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Disconnect"
                        }
                    ]
                })
            }),
            isDeveloper || applications != null && applications.length > 0 ? /*#__PURE__*/ _jsxs(React.Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        size: "sm",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "F8Xp9u",
                            defaultMessage: "Your Applications"
                        })
                    }),
                    (applications !== null && applications !== void 0 ? applications : []).map(function(application) {
                        return /*#__PURE__*/ _jsx(UnstyledButton, {
                            className: styles.applicationButton,
                            onClick: function() {
                                return navigate(DynamicWebRoutes.OAUTH2_APPLICATION_SETTINGS(application.clientId));
                            },
                            children: /*#__PURE__*/ _jsx(SettingsPanel, {
                                icon: faCube,
                                heading: application.name,
                                description: intl.formatMessage({
                                    id: "kNp7lL",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Created "
                                        },
                                        {
                                            type: 1,
                                            value: "time"
                                        }
                                    ]
                                }, {
                                    time: dayjs(application.createdAt).fromNow()
                                }),
                                afterElement: /*#__PURE__*/ _jsx(Icon, {
                                    icon: faChevronRight
                                })
                            })
                        }, application._id);
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.newApplicationButton,
                        children: /*#__PURE__*/ _jsx(Button, {
                            size: "sm",
                            onClick: newApplicationModalHandlers.open,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "HOulGI",
                                defaultMessage: "New application"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(InputModal, {
                        isOpen: newApplicationModalOpen,
                        onClose: newApplicationModalHandlers.close,
                        title: intl.formatMessage({
                            id: "rH2lef",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "New Application"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "buF63x",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Create a new OAuth2 application."
                                }
                            ]
                        }),
                        onSubmit: createApplication,
                        submitText: intl.formatMessage({
                            id: "VzzYJk",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Create"
                                }
                            ]
                        }),
                        renderInput: function(inputProps) {
                            return /*#__PURE__*/ _jsx(DefaultInput, _object_spread({
                                placeholder: intl.formatMessage({
                                    id: "pzqfeH",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Application Name"
                                        }
                                    ]
                                })
                            }, inputProps));
                        }
                    })
                ]
            }) : null
        ]
    });
}
export default ConnectionsPanel;
